import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'setStepActiveKey',
    position: [ButtonPosition.step],
    action: (arg) => {
        const { buttonConfig, _context } = arg || {};
        const { options } = buttonConfig || {};
        const { activeKey, _bindStep } = options || {};
        if (activeKey && _bindStep) {
            const dom = _context?.$?.(_bindStep);
            if (typeof dom?.changeStep === 'function') {
                dom.changeStep(activeKey, { needSetState: true });
            }
        }
    },
};
